import BuyerTopBarMetrics from '@components/layout/side-nav/bars/top-bar/buyer-top-bar-metrics';
import type { TopBarDashboardResponse } from '@components/layout/side-nav/bars/top-bar/topBarTypes';
import { TOP_BAR_HEIGHT } from '@components/layout/side-nav/layout/layoutStyle';
import BuyerJobs from '@features/buyer/jobs/buyer-jobs';
import { NotificationsCard } from '@features/r8tr/notifications/notifications-card';
import { useDashboardQuery } from '@lib/api/dashboard';
import { useProfileQuery } from '@lib/api/profile';
import Box from '@mui/material/Box';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import type { UserDetails } from './userTypes';

const SIDEBAR_WIDTH = 340;
const SIDEBAR_STICKY_TOP = TOP_BAR_HEIGHT + 16;
const SIDEBAR_STATS_HEIGHT = 96;
const NOTIFICATIONS_HEADER_HEIGHT = 64;
const SIDEBAR_LIST_MAX_HEIGHT = `calc(100dvh - ${
  SIDEBAR_STICKY_TOP + SIDEBAR_STATS_HEIGHT + NOTIFICATIONS_HEADER_HEIGHT + 24
}px)`;

const BuyerDashboard = (): JSX.Element => {
  const navigator = useNavigate();
  const [showDashboard, setShowDashboard] = useState(false);
  const { data } = useProfileQuery();
  const userDetails = data as UserDetails | undefined;
  const { data: dashboardBody = {} } = useDashboardQuery();
  const stats = (dashboardBody as TopBarDashboardResponse).data;

  useEffect(() => {
    if (localStorage.getItem('userRole') === 'buyer') {
      const user = userDetails?.data?.user;
      if (user?.phoneNumber) {
        if (
          user.firstName == null ||
          user.firstName === '' ||
          user.email == null ||
          user.email === ''
        ) {
          navigator('/personal-info');
        } else {
          setShowDashboard(true);
        }
      }
    } else {
      setShowDashboard(true);
    }
  }, [userDetails, navigator]);

  if (!showDashboard) {
    return <Box />;
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 3,
        width: '100%',
        maxWidth: 1120,
        mx: 'auto',
        px: { xs: 2, md: 4 },
        py: 3,
      }}
    >
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: {
            xs: 'minmax(0, 1fr)',
            lg: `minmax(0, 1fr) ${SIDEBAR_WIDTH}px`,
          },
          alignItems: 'start',
          gap: 3,
        }}
      >
        <Box sx={{ minWidth: 0 }}>
          <BuyerJobs />
        </Box>
        <Box component="aside" sx={{ alignSelf: { lg: 'stretch' } }}>
          <Box
            sx={{
              position: { lg: 'sticky' },
              top: { lg: SIDEBAR_STICKY_TOP },
              display: 'flex',
              flexDirection: 'column',
              gap: 2,
            }}
          >
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: 1,
                '& > *': { width: '100%', boxSizing: 'border-box' },
              }}
            >
              <BuyerTopBarMetrics
                ratingsCompleted={stats?.ratingsCompleted}
                rating={stats?.currentBuyerRating}
              />
            </Box>
            <NotificationsCard
              listMaxHeight={{ xs: 320, lg: SIDEBAR_LIST_MAX_HEIGHT }}
            />
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default BuyerDashboard;
